import { ModalProps } from "react-bootstrap";
import TermsOfUseContent from "../data/termsOfUseContent";
import LegalDocumentModal from "./LegalDocumentModal";

interface TermsOfUseModalProps extends ModalProps {
  show: boolean;
  onHide: () => void;
}

const TermsOfUseModal = ({ show, onHide, ...props }: TermsOfUseModalProps) => (
  <LegalDocumentModal
    {...props}
    show={show}
    onHide={onHide}
    title="Terms of Use"
  >
    <TermsOfUseContent />
  </LegalDocumentModal>
);

export default TermsOfUseModal;
